module.exports = __webpack_public_path__ + "img/homeactive.34310341.svg";